import { useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import { Grid, Typography, Tooltip, TextField, Button, CardContent, LinearProgress } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { getCurrentDate } from "../functions/current";
import { toast } from "react-toastify";
import config from '../config.json';
import { apiRequest } from "../functions/apiRequest";
import { bulkUploadImagesToCloudinary } from "../functions/cloudinaryBulkUpload";
import { checkIfAdmin } from "../functions/helpers/user";
import DraggableImageGrid from '../customComponents/DraggableImageGrid';
import { useNavigate } from "react-router-dom";

const PREFIX = 'createProgram';

const classes = {
  paper: `${PREFIX}-paper`,
  popover: `${PREFIX}-popover`
};

const Root = styled('div')({
  [`& .${classes.paper}`]: {
    fontFamily: "Raleway",
    fontSize: "18",

    marginTop: 20,
  },
  [`& .${classes.popover}`]: {
    pointerEvents: "none",
  },
});

export default function CreatePrograms() {
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  const userID = parseInt(localStorage.getItem("userID"));

  const [images, setImages] = useState([]);
  const [badgeImage, setBadgeImage] = useState([]);
  const [eventActStatus, setEventActStatus] = useState(true);
  const totalMaxLength = parseInt(process.env.REACT_APP_MAX_CHARACTERS_FOR_CERTIFICATE)
  const [maxCertificateDescriptionLength, setMaxCertificateDescriptionLength] = useState(totalMaxLength);
  const [isLoading, setIsLoading] = useState(false);
  const [submitHit, setSubmitHit] = useState(false);

  // useEffect(() => {
  //   async function fetchData() {
  //     if (await checkIfAdmin(userID, token)) {
  //       setEventActStatus(true)
  //     } else {
  //       setEventActStatus(false)
  //     }
  //   }
  //   fetchData()
  //   // Checking the whether program creator is admin ends
  //   // eslint-disable-next-line
  // }, []);

  // changes will affect on selection of image
  const handleImageChange = (e) => {
    const filesArray = Array.from(e.target.files);
    setImages((prev) => (Array.isArray(prev) ? [...prev, ...filesArray] : filesArray));
  };

  const handleRemoveSelectedFile = (indexToRemove) => {
    setImages((prev) => (Array.isArray(prev) ? prev.filter((_, idx) => idx !== indexToRemove) : []));
  };

  const handleBadgeImageChange = (e) => {
    const filesArray = Array.from(e.target.files);
    setBadgeImage(filesArray);
  };

  const handleRemoveSelectedBadge = () => {
    setBadgeImage([]);
  };

  const checkValid = (data) => {
    if (!data.program_name || String(data.program_name).trim().length === 0) return false;
    if (!data.program_description || String(data.program_description).trim().length === 0) return false;
    if (!data.start_date || String(data.start_date).trim().length === 0) return false;
    return true;
  };

  const handleSubmit = async (e) => {
    try {
      let imagelist = [];
      setSubmitHit(true);
      e.preventDefault();
      let badgeImageUrl = null;
      if (checkValid(formData)) {
        setIsLoading(true);
        if (images) {
          imagelist = await bulkUploadImagesToCloudinary(images);
        }

        if (badgeImage) {
          const badgeUrls = await bulkUploadImagesToCloudinary(badgeImage);
          badgeImageUrl = badgeUrls[0];
          imagelist.push(badgeImageUrl);
        }

        const programBody = {
          founder_Name: localStorage.getItem("first_name"),
          program_name: formData.program_name,
          program_description: formData.program_description,
          start_date: formData.start_date,
          end_date: formData.end_date,
          impact_int: formData.impact_int,
          impact_units: formData.impact_units,
          impact_char: formData.impact_char,
          redemption: ["Exchange", "Gift", "Certificate"],
          images: imagelist,
          approval_status: eventActStatus,
          certificate_description: formData.certificate_description,
          badge: badgeImageUrl
        };

        const data = await apiRequest('post', JSON.stringify(programBody), "/program/create/", token);

        if (data[0].id) {
          toast.success("Your program is live");
          navigate(`/program/${data[0].id}`);

        //   setIsLoading(false);
        //   const body2 = {
        //     creds: 0,
        //     clocked_hours: 0,
        //     message: `Wants to create a new Program. A little about the event: ${formData.program_description}`,
        //     date: "",
        //     from_user: userID,
        //     to_user: 1,
        //     program: data[0].id,
        //     from_username: localStorage.getItem("first_name"),
        //     notif_type: "3",
        //   };

        //   await apiRequest('post', JSON.stringify(body2), "/notif/send/1", token);

        //   // toast.success("Request sent");
        //   setTimeout(() => {
        //     window.location.href = "/dashboard";
        //   }, 2000);

        }
      }

    } catch (err) {

    }
  };
  const initialFormData = Object.freeze({
    founder_Name: localStorage.getItem("first_name"),
    program_name: "",
    program_description: "",
    start_date: "",
    impact_int: 100000,
    impact_units: "Hours",
    impact_char: "Tech Scoping",
    redemption: ["Exchange", "Gift", "Certificate"],
    certificate_description: ''
  });
  const [formData, updateFormData] = useState(initialFormData);

  const handleChange = (e) => {
    let trimmedValue = e.target.value.trim();
    if (e.target.name === 'program_name' && maxCertificateDescriptionLength > 0) {
      setMaxCertificateDescriptionLength(totalMaxLength - trimmedValue.length)
    }
    updateFormData({
      ...formData,
      [e.target.name]: trimmedValue.trim(),
    });
  };
  if (!isLoading) {
    return (
      <Root style={{ padding: '3.5vw' }}>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={12} md={8} style={{ paddingTop: '5vh' }}>
            <Typography
              component="h1"
              style={{
                borderRadius: 20,
                fontSize: 36,
                fontFamily: "Raleway",
              }}
            >
              <strong>CREATE YOUR PROGRAM</strong>
            </Typography>
            <Typography
              component="h1"
              style={{
                borderRadius: 20,
                fontSize: 22,
                marginTop: 10,
                fontFamily: "Raleway",
              }}
            >
              All fields are required*
            </Typography>
            <Grid item xs={12} md={8}>
              <Typography className={classes.paper}>
                <strong>What do you want to call your new program?</strong>
                <Tooltip title="Example: Trash Mafia Kids, Speak Easy " arrow>
                  <InfoIcon style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />
                </Tooltip>
              </Typography>
              <TextField
                variant="outlined"
                name="program_name"
                type="title"
                id="title"
                size="small"
                fullWidth
                style={{ height: 40 }}
                onChange={handleChange}
                inputProps={{ maxLength: 50 }}
                error={submitHit && formData.program_name.length === 0}
              />
            </Grid>
            <Grid item md={8} xs={12}>
              <Typography
                className={classes.paper}
                style={{ fontFamily: "Raleway" }}
              >
                <strong>Describe your social initiative.</strong>
                <Tooltip
                  title="Example:collecting trash to recycle and raise funds "
                  arrow
                >
                  <InfoIcon style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />
                </Tooltip>
              </Typography>
              <TextField
                variant="outlined"
                fullWidth
                multiline
                name="program_description"
                type="description"
                id="description"
                size="small"
                onChange={handleChange}
                error={submitHit && formData.program_description.length === 0}
              />
              <Typography
                className={classes.paper}
                style={{ fontFamily: "Raleway" }}
              >
                <strong>Your program tag line or one short sentence to describe your program.</strong>
                <Tooltip
                  title="Saving the Earth one bin at a time"
                  arrow
                >
                  <InfoIcon style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }} />
                </Tooltip>
              </Typography>
              <TextField
                variant="outlined"
                fullWidth
                multiline
                name="certificate_description"
                type="certificate_description"
                id="certificate_description"
                inputProps={{ maxLength: maxCertificateDescriptionLength }}
                size="small"
                onChange={handleChange}
                error={submitHit && formData.certificate_description.length === 0}
              />
            </Grid>
            <Grid container>
              <Grid item xs={12} md={5}>
                <Typography className={classes.paper}>
                  <strong>Start date of the program</strong>
                </Typography>

                <TextField
                  id="start_date"
                  name="start_date"
                  type="date"
                  size="small"
                  variant="outlined"
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={submitHit && formData.start_date.length === 0}
                />
              </Grid>
              <Grid item xs={12} md={5}>
                <Typography className={classes.paper}>
                  <strong>Estimated end date of the program (optional)</strong>
                </Typography>

                <TextField
                  id="end_date"
                  name="end_date"
                  type="date"
                  size="small"
                  variant="outlined"
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{ min: getCurrentDate() }}
                />
              </Grid>
            </Grid>
            <Grid item md={8} xs={12}>
              <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 8, marginTop: 10 }}>
                Program Images
              </Typography>
              <input
                type="file"
                id="images"
                accept="image/png, image/jpeg, image/jpg"
                multiple
                onChange={handleImageChange}
                style={{ border: "none", outline: "none", cursor: "pointer" }}
              />
              <DraggableImageGrid
                items={images || []}
                onReorder={(newFiles) => setImages(newFiles)}
                onDelete={(idx) => handleRemoveSelectedFile(idx)}
              />

              <br />
              <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 8, marginTop: 12 }}>
                Upload your program logo / badge (Used in Certificate)
              </Typography>
              <input
                type="file"
                id="badge"
                accept="image/png, image/jpeg, image/jpg"
                onChange={handleBadgeImageChange}
                style={{ border: submitHit && Object.keys(badgeImage).length === 0 ? "1px solid red" : "none", outline: "none", cursor: "pointer" }}
              />
              <DraggableImageGrid
                items={badgeImage || []}
                onReorder={(newFiles) => setBadgeImage(newFiles)}
                onDelete={() => handleRemoveSelectedBadge()}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Button
                type="submit"
                variant="contained"
                style={{
                  backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                  color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
                  borderRadius: 30,
                  fontFamily: "Raleway",
                  marginTop: 28,
                  marginBottom: 30,
                }}
                onClick={handleSubmit}
              >
                Create Program
              </Button>
            </Grid>

          </Grid>
        </Grid>
      </Root>
    );
  } else {
    return (
      <div style={{ marginTop: 20, textAlign: "center" }}>
        <img alt={'logo'} style={{ height: 350, width: 300 }} src={`${process.env.REACT_APP_R2_URL}/general/time_creds_logo.png`} />
        <LinearProgress />
      </div>
    );
  }

}
